export default __webpack_public_path__ + "static/list-on-asx-95914001635ff38306854d6ac1073e37.jpg";